<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('classTeaching.chooseStatus') }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{
                $t('classTeaching.studentStatus')
              }}</label>
              <div>
                <select class="form-control" v-model="status_id">
                  <option value="">{{ $t('clasSteaching.all') }}</option>
                  <option :value="1">{{ $t('clasSteaching.active') }}</option>
                  <option :value="2">{{
                    $t('clasSteaching.dropedOut')
                  }}</option>
                  <option :value="3">{{ $t('clasSteaching.suspend') }}</option>
                  <option :value="4">{{
                    $t('clasSteaching.terminated')
                  }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button class="btn-sm" @click.prevent="$emit('close')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              @click.prevent="pdf"
              >{{ $t('preview') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import ChooseStatus from './preview-pdf'
export default {
  props: ['record'],
  name: 'chooseStatus',
  data() {
    return {
      status_id: 1
    }
  },
  methods: {
    pdf() {
      this.$emit('close')
      this.$modal.show(
        ChooseStatus,
        {
          data: this.record,
          status_id: this.status_id
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  }
}
</script>
